import {
  queryExpandPlatformType,
  queryBankFrom,
  bandingBankInfo,
  queryLotUserBankInfo,
  queryCustomerFeedbackList,
  addCustomerFeedback,
  updatePhone,
  updateName,
  smsYunXinPhone,
  updateNickName,
  modifyPassword,
  setPayPwd,
  getUserPayPwd,
  queryRechargeList,
  queryBalance,
  getUsablePayType,
  recharge,
  updateUserImg,
  queryTakeFeeList,
  takeFee,
  agreeYeb,
  yebTransform,
  queryYebTradeList,
  queryUserYebInterest,
  queryUserYebInfo,
  balanceAdnSign,
  userInfo,
  turnTable,
  redpacketSetting_info,
  myPrize,
  redpacket_take,
  turntable_pattern,
  getPlayAccount,
  queryUserExpandList,
  randomExpand,
  addExpand,
  modifyExpand,
  deleteExpand,
  queryBalanceDetailList,
  redpacket_me,
  redpacket_pattern,
  get_redpacket,
  redpacketStatus,
  receiveRedpacket,
  sign,
  sendRedpacket,
  redpacketChatConfig,
  rankOfProfit,
  rankOfRecharge,
  queryUnclaimedRedpacket,
  loginOut,
  queryUserMessage,
  isqueryUserMessage,
  /*    queryExpandPlatformType, */
  login,
  register,
  passWordUserCode,
  getUserLoginLog,
  resetLoginPwd,
  getUserChatRank,
  queryUserInfo,
  queryFavoritesList,
  saveFavoritesList,
  deleteFavoritesList,
  queryCurrencyExchangeInfo,
  queryCurrencyExchangeByScur
} from "@/api/user";
import { queryLotUserAccount } from "@/api/game";
import { isNotEmpty } from "@/utils";

import {
  ADD_USER_EXPANDPLATFORM_TYPE,
  SET_USER_INFO,
  SET_USER_KEY_VAL,
  SET_CHATUSER_KEY_VAL,
  SET_USER_YEB_INFO,
  SET_USER_LOT_USER_ACCOUNT,
  SET_USER_UNCLAIMED_REDPACKET,
  SET_SYS_EXCHANGE_INFO
} from "@/store/mutation_types";
import { isEmpty } from "@/utils/index";
import store from "@/store";

let localUser = localStorage.getItem("user");
// 后加的元素添加默认值才会被监听
const user = {
  state: {
    expandPlatFormTypes: [],
    user: isNotEmpty(localUser) ? JSON.parse(localUser) : {},
    yebInfo: {},
    lotUserAccount: [],
    userUnclaimedRedPacket: {},
    currencyExchangeInfo: [],
    sysExchangeInfo: {}
  },
  getters: {
    userExpandPlatFormTypes: state => state.expandPlatFormTypes,
    isTryUser: state => state.user.userType == "09",
    isUnUser: state => !state.user.userId,
    isLoginUser: state => !!state.user.userId,
    user: state => state.user,
    userYebInfo: state => state.yebInfo,
    userAreaCode: state => state.user && state.user.areaCode,
    lotUserAccount: state => state.lotUserAccount,
    userUnclaimedRedPacket: state => state.userUnclaimedRedPacket,
    currencyExchangeInfo: state => state.currencyExchangeInfo,
    sysExchangeInfo: state => state.sysExchangeInfo
  },
  mutations: {
    [SET_SYS_EXCHANGE_INFO](state, playload) {
      state.sysExchangeInfo = playload;
    },
    [ADD_USER_EXPANDPLATFORM_TYPE]: (state, playload) => {
      const { types } = playload;
      state.exandPlatFormTypes = types;
    },
    [SET_USER_INFO]: (state, user) => {
      state.user = (isNotEmpty(user) && Object.assign({}, user)) || {};
      localStorage.setItem("user", JSON.stringify(state.user));
    },
    [SET_USER_KEY_VAL]: (state, playload) => {
      for (let k in playload) {
        state.user[k] = playload[k];
      }
      localStorage.setItem("user", JSON.stringify(state.user));
    },
    [SET_USER_YEB_INFO]: (state, playload) => {
      state.yebInfo = playload;
    },
    [SET_USER_LOT_USER_ACCOUNT]: (state, playload) => {
      state.lotUserAccount = playload;
    },
    [SET_USER_UNCLAIMED_REDPACKET]: (state, playload) => {
      state.userUnclaimedRedPacket = playload;
    },
    getUserAreaCode(state, areaCode) {
      state.user.areaCode = areaCode;
      localStorage.setItem("user", JSON.stringify(state.user));
    }
  },
  actions: {
    async queryCurrencyExchangeByScur(
      { state, rootGetters, commit, dispatch },
      playload = {}
    ) {
      // if (!rootGetters.isLoginUser) {
      //   return
      // }
      const { scur } = playload;
      const res = await queryCurrencyExchangeByScur({ scur });
      if (res.data.code !== 0) {
        return;
      }
      // const exchangeInfo = res.data.data;
      const exchangeInfo = {
        ...res.data.data,
        scurIcon: res.data.data.icon,
        tcur: rootGetters.sysCurrency.currency,
        tcurIcon: rootGetters.sysCurrency.currencyIcon
      };
      return exchangeInfo;
    },
    async querySysExChangeInfo(
      { state, rootGetters, commit, dispatch },
      playload
    ) {
      if (!rootGetters.isLoginUser) {
        return;
      }
      if (!rootGetters.sysApiCoin.cur) {
        await dispatch("querySystemConfig");
      }
      let res = null;
      try {
        res = await queryCurrencyExchangeInfo();
      } catch (e) {
        console.log("ee", e);
      }
      if (res.data.code !== 0) {
        return;
      }
      const exchangeInfo = {
        ...res.data.data,
        scurIcon: res.data.data.icon,
        tcur: rootGetters.sysCurrency.currency,
        tcurIcon: rootGetters.sysCurrency.currencyIcon
      };
      commit(SET_SYS_EXCHANGE_INFO, exchangeInfo);
      return exchangeInfo;
    },
    setUserNickName({ commit }, playload) {
      commit(SET_USER_KEY_VAL, {
        nickName: playload
      });
      commit(SET_CHATUSER_KEY_VAL, {
        nickName: playload
      });
    },
    setUserResetMoney({ commit }, playload) {
      commit(SET_USER_KEY_VAL, {
        resetMoney: playload
      });
      commit(SET_CHATUSER_KEY_VAL, {
        resetMoney: playload
      });
    },
    SetClearBettingList({ commit }, playload) {
      commit(SET_USER_KEY_VAL, {
        bettingList: playload
      });
      commit(SET_CHATUSER_KEY_VAL, {
        bettingList: playload
      });
    },
    async queryExpandPlatformType({ commit }, playload) {
      const res = await queryExpandPlatformType(playload);
      const {
        data: { data = {} }
      } = res;
      commit(ADD_USER_EXPANDPLATFORM_TYPE, data);
      return res;
    },
    async queryUserBankFrom({ commit }, playload) {
      return await queryBankFrom(playload.data, playload.config);
    },
    async bandingUserBankInfo({ commit }, playload) {
      return await bandingBankInfo(playload);
    },
    async queryLotUserBankInfo({ commit }, playload) {
      return await queryLotUserBankInfo(playload.data, playload.config);
    },
    async queryCustomerFeedbackList({ commit }, playload) {
      return await queryCustomerFeedbackList(playload.data, playload.config);
    },
    async addCustomerFeedback({ commit }, playload) {
      return await addCustomerFeedback(playload.data, playload.config);
    },
    async updateUserPhone({ commit }, playload) {
      return await updatePhone(playload.data, playload.config);
    },
    async updateUserName({ commit }, playload) {
      return await updateName(playload);
    },
    async smsYunXinPhone({ commit }, playload) {
      return await smsYunXinPhone(playload.data, playload.config);
    },
    async updateUserNickName({ commit }, playload) {
      return await updateNickName(playload.data, playload.config);
    },
    async modifyUserPassword({ commit }, playload) {
      return await modifyPassword(playload.data, playload.config);
    },
    async setUserPayPwd({ commit }, playload) {
      return await setPayPwd(playload.data, playload.config);
    },
    async getUserPayPwd({ commit }, playload) {
      return await getUserPayPwd(playload.data, playload.config);
    },
    async queryUserRechargeList({ commit }, playload) {
      return await queryRechargeList(playload.data, playload.config);
    },
    async queryUserBalance({ commit, state }, playload) {
      const resp = await queryBalance(playload.data, playload.config);
      if (resp.data.code == 0) {
        commit(SET_USER_KEY_VAL, {
          balance: resp.data.data.balance
        });
        commit(SET_USER_KEY_VAL, {
          balanceWithDraw: resp.data.data.balanceWithDraw
        });
      }
      return resp;
    },
    async queryLoginLotUserAccount({ commit, state }, playload = {}) {
      const res = await queryLotUserAccount(playload.data, playload.config);
      if (res.data.code === 0) {
        commit(SET_USER_LOT_USER_ACCOUNT, res.data.data);
      }
      return res;
    },
    async getUserUsablePayType({ commit }, playload) {
      return await getUsablePayType(playload.data, playload.config);
    },

    async userRecharge({ commit }, playload) {
      const config = playload.config || {};
      config.timeout = 30 * 1000;
      return await recharge(playload.data, config);
    },
    async updateUserImg({ commit }, playload) {
      return await updateUserImg(playload.data, playload.config);
    },
    async queryUserTakeFeeList({ commit }, playload) {
      return await queryTakeFeeList(playload.data, playload.config);
    },
    async userTakeFee({ commit }, playload) {
      return await takeFee(playload.data, playload.config);
    },
    async agreeUserYeb({ commit }, playload) {
      return await agreeYeb(playload.data, playload.config);
    },
    async yebTransform({ commit }, playload) {
      const res = await yebTransform(playload.data, playload.config);
      return res;
    },
    async queryYebTradeList({ commit }, playload) {
      return await queryYebTradeList(playload.data, playload.config);
    },
    async queryUserYebInterest({ commit }, playload) {
      return await queryUserYebInterest(playload.data, playload.config);
    },
    async queryUserYebInfo({ commit }, playload) {
      let res = await queryUserYebInfo(playload.data, playload.config);
      // console.log('yebinfo', res)
      if (res.data.code == 0) {
        commit(SET_USER_YEB_INFO, res.data.data);
      }
      return res;
    },
    async balanceAdnSign({ commit, state }, playload) {
      const resp = await balanceAdnSign(playload.data, playload.config);
      const { data, code } = resp.data;
      if (code == 0) {
        let user = state.user;
        user = Object.assign(user, data);
        if (user.levelId) {
          user.userLevel = user.levelId;
        }
        commit(SET_USER_INFO, user);
      }
      return resp;
    },
    async turnTableUserInfo({ commit }, playload) {
      return await userInfo(playload.data, playload.config);
    },
    async turnTable({ commit }, playload) {
      return await turnTable(playload.data, playload.config);
    },
    async redpacketSetting_info({ commit }, playload) {
      return await redpacketSetting_info(playload.data, playload.config);
    },
    async turnTableMyPrize({ commit }, playload) {
      return await myPrize(playload.data, playload.config);
    },
    async redpacket_take({ commit }, playload) {
      return await redpacket_take(playload.data, playload.config);
    },
    async turntable_pattern({ commit }, playload) {
      return await turntable_pattern(playload.data, playload.config);
    },

    async getPlayAccount({ commit }, playload) {
      return await getPlayAccount(playload.data, playload.config);
    },
    async queryUserExpandList({ commit }, playload) {
      return await queryUserExpandList(playload.data, playload.config);
    },
    async randomUserExpand({ commit }, playload) {
      return await randomExpand(playload.data, playload.config);
    },
    async addUserExpand({ commit }, playload) {
      return await addExpand(playload.data, playload.config);
    },
    async modifyUserExpand({ commit }, playload) {
      return await modifyExpand(playload.data, playload.config);
    },
    async deleteUserExpand({ commit }, playload) {
      return await deleteExpand(playload.data, playload.config);
    },
    async queryBalanceDetailList({ commit }, playload) {
      return await queryBalanceDetailList(playload.data, playload.config);
    },
    async redpacket_me({ commit }, playload) {
      return await redpacket_me(playload.data, playload.config);
    },
    async redpacket_pattern({ commit }, playload) {
      return await redpacket_pattern(playload.data, playload.config);
    },
    async get_redpacket({ commit }, playload) {
      return await get_redpacket(playload.data, playload.config);
    },
    async redpacketStatus({ commit }, playload) {
      return await redpacketStatus(playload.data, playload.config);
    },
    async chatReceiveRedpacket({ commit }, playload) {
      return await receiveRedpacket(playload.data, playload.config);
    },

    async signUser({ commit }, playload) {
      const resp = await sign(playload.data, playload.config);
      if (resp.data.code == 0) {
        // debugger
        commit(SET_USER_KEY_VAL, {
          signFlag: "1"
        });
      }
      return resp;
    },
    async sendUserRedpacket({ commit }, playload) {
      return await sendRedpacket(playload.data, playload.config);
    },
    async redpacketChatConfig({ commit }, playload) {
      return await redpacketChatConfig(playload.data, playload.config);
    },
    async rankOfProfit({ commit }, playload) {
      return await rankOfProfit(playload.data, playload.config);
    },
    async rankOfRecharge({ commit }, playload) {
      return await rankOfRecharge(playload.data, playload.config);
    },
    async queryUnclaimedRedpacket({ commit }, playload) {
      const resp = await queryUnclaimedRedpacket(
        playload.data,
        playload.config
      );
      if (resp.data.code == 0) {
        commit(SET_USER_UNCLAIMED_REDPACKET, resp.data.data);
      }
      return resp;
    },

    async queryUserMessage({ commit }, playload) {
      return await queryUserMessage(playload.data, playload.config);
    },
    async isqueryUserMessage({ commit }, playload) {
      return await isqueryUserMessage(playload.data, playload.config);
    },
    /*  async queryExpandPlatformType({ commit }, playload) {
      return await queryExpandPlatformType(playload.data, playload.config);
    }, */
    async loginOutUser({ commit }, playload) {
      const resp = await loginOut(playload.data, playload.config);
      if (resp.data.code == 0) {
        commit(SET_USER_INFO, {});
      }
      return resp;
    },
    async loginUser({ commit }, playload) {
      const resp = await login(playload.data, playload.config);
      if (resp.data.code == 0) {
        console.log(
          JSON.stringify(resp.data.data),
          "===============================login"
        );
        commit(SET_USER_INFO, resp.data.data);
      }
      return resp;
    },
    setLoginUser({ commit }, user) {
      commit(SET_USER_INFO, user);
    },
    async passWordUserCode({ commit }, playload) {
      const resp = await passWordUserCode(playload.data, playload.config);

      if (resp.data.code == 0) {
        // commit(SET_USER_INFO, resp.data.data);
      }
      return resp;
    },
    async resetLoginPwd({ commit }, playload) {
      const resp = await resetLoginPwd(playload.data, playload.config);
      return resp;
    },
    async registerUser({ commit }, playload) {
      const resp = await register(playload.data, playload.config);
      if (resp.data.code == 0) {
        commit(SET_USER_INFO, resp.data.data);
      }
      return resp;
    },
    async getUserLoginLog({ commit }, playload) {
      const resp = await getUserLoginLog();
      return resp;
    },
    async getUserChatRank({ commit }, playload) {
      return await getUserChatRank(playload);
    },
    async queryUserInfo({ commit }, playload) {
      return await queryUserInfo(playload);
    },
    async queryFavoritesList({ commit }, playload) {
      return await queryFavoritesList(playload);
    },
    async saveFavoritesList({ commit }, playload) {
      return await saveFavoritesList(playload);
    },
    async deleteFavoritesList({ commit }, playload) {
      return await deleteFavoritesList(playload);
    }
  }
};
export default user;
